<ng-container *transloco="let t">
    <div class="flex flex-col flex-auto md:w-180 md:min-w-180 min-h-80 max-h-90vh -m-6">

        <div *ngIf="!editMode">
            <!-- Title -->
            <div class="flex flex-col items-center px-4 md:px-12 pt-4 border-b bg-gray-100 dark:bg-gray-700 pb-4">
                <ng-container *ngIf="service.title">
                    <div class="font-semibold text-center flex items-center text-3xl ml-4">
                        {{service.title}}
                    </div>
                </ng-container>
            </div>

            <div class="grid grid-cols-10 justify-center text-center gap-3 md:gap-6 py-4 px-4 sm:px-14">
                <div class="flex col-span-10 sm:col-span-5 md:col-span-3">
                    <!-- Image -->
                    <ng-container *ngIf="service.image">
                        <div *ngIf="service.image.endsWith('.svg')" [inlineSVG]="service.image"
                            class="service-image-container w-full h-36 mt-4 rounded-2xl"></div>
                        <img *ngIf="!service.image.endsWith('.svg')" [src]="service.image"
                            class="w-full object-contain h-36 mt-4 rounded-2xl" draggable="false">
                    </ng-container>
                </div>
                <div class="flex col-span-10 sm:col-span-5 md:col-span-7">
                    <!-- Description -->
                    <ng-container *ngIf="service.description">
                        <p [innerHTML]="service.description"
                            class="text-justify mt-4 overflow-y-auto max-h-80 px-2 mb-4"></p>
                    </ng-container>
                </div>

                <div *ngIf="service.shouldSelectRelease && (user.role === 'user' || user.role === 'label')"
                    class="flex flex-col col-span-10 text-left">
                    <div class="mt-2 leading-tight">Please select the release for which you want to order this service:
                    </div>
                    <div class="flex flex-col md:flex-row mt-2 space-x-2">
                        <mat-form-field class="flex-auto w-full text-sm sm:text-base">
                            <mat-select [(ngModel)]="selectedReleaseId" required>
                                <ng-container *ngFor="let release of releases">
                                    <mat-option [value]="release.uuid">
                                        {{release.title}}
                                    </mat-option>
                                </ng-container>
                            </mat-select>
                        </mat-form-field>
                    </div>
                </div>

                <div *ngIf="service.shouldSelectLabel && (user.role === 'user' || user.role === 'label')"
                    class="flex flex-col col-span-10 text-left">
                    <div class="mt-2 leading-tight">Please select the label for which you want to order this service:
                    </div>
                    <div class="flex flex-col md:flex-row mt-2 space-x-2">
                        <mat-form-field class="flex-auto w-full text-sm sm:text-base">
                            <mat-select [(ngModel)]="selectedLabelId" required>
                                <ng-container *ngFor="let label of getLabelsWithoutBeatportPermission()">
                                    <mat-option [value]="label.uuid">
                                        {{label.title}}
                                    </mat-option>
                                </ng-container>
                            </mat-select>
                        </mat-form-field>
                    </div>
                </div>
            </div>


            <div
                class="flex flex-auto flex-col sm:flex-row justify-between items-center bg-gray-100 dark:bg-gray-700 p-4 space-y-4 md:space-y-0">
                <div class="flex flex-col px-4 sm:px-8">
                    <div *ngIf="service.price > 0">
                        <span class="text-4xl font-semibold leading-tight">
                            {{service.price * (platform.salesTax + 1) | currency: platform.currency}}
                        </span>
                        <div>
                            {{'incl. ' + (service.price * platform.salesTax | currency:platform.currency) + ' VAT'}}
                        </div>
                    </div>

                    <div *ngIf="service.price === 0">
                        <span class="text-4xl font-semibold leading-tight">
                            {{t('service-no-cost')}}
                        </span>
                    </div>

                    <div *ngIf="user.role === 'user' || user.role === 'label'" class="flex flex-row items-start mt-4">
                        <div>
                            <div><b>Billing Address</b></div>
                            <div *ngIf="user.personalInformation.company">{{user.personalInformation.company}}</div>
                            <div *ngIf="!user.personalInformation.company">{{user.personalInformation.firstName}}
                                {{user.personalInformation.lastName}}</div>
                            <div>{{user.personalInformation.address}}</div>
                            <div>{{user.personalInformation.zipCode}} {{user.personalInformation.city}}</div>
                            <div>{{user.personalInformation.country ? ("cc." + user.personalInformation.country.alpha2 |
                                transloco) : ""}}</div>
                        </div>
                        <button (click)="closeModal()" class="min-w-10 min-h-7 h-7 px-2 leading-6 ml-4"
                            mat-stroked-button routerLink="./settings">
                            <mat-icon [svgIcon]="'heroicons_solid:pencil'" class="icon-size-4"></mat-icon>
                        </button>
                    </div>
                </div>
                <div
                    *ngIf="isPaymentMethodEnabled('balance') && (user.role === 'user' || user.role === 'label') && (!!selectedReleaseId || !service.shouldSelectRelease) && (!!selectedLabelId || !service.shouldSelectLabel)">
                    <div *ngIf="service.price > 0" class="flex flex-col px-4 sm:px-8 my-auto space-y-4">
                        <div [matTooltip]="user.balance < service.price ? t('not-enough-balance') : ''">
                            <button (debounceClick)="orderWithBalance()" [debounceTime]="3000" appDebounceClick
                                [disabled]="user.balance < service.price" class="bg-white w-full" mat-stroked-button>
                                <mat-icon [svgIcon]="'heroicons_outline:shopping-cart'"></mat-icon>
                                <span class="ml-2 mr-1">Balance <span class="text-md text-gray-500">({{user.balance |
                                        currency:platform.currency}})</span></span>
                            </button>
                        </div>

                        <ngx-paypal *ngIf="isPaymentMethodEnabled('paypal')" [config]="payPalConfig"></ngx-paypal>

                        <button *ngIf="isPaymentMethodEnabled('stripe')" (debounceClick)="orderWithStripe()"
                            [debounceTime]="3000" appDebounceClick [color]="'primary'" mat-flat-button>
                            <mat-icon [svgIcon]="'heroicons_outline:credit-card'"></mat-icon>
                            <span class="ml-2 mr-1">Credit Card</span>
                        </button>
                    </div>

                    <div *ngIf="service.price === 0">
                        <button (debounceClick)="orderFreeService()" [debounceTime]="3000" appDebounceClick
                            [color]="'primary'" class="my-auto" mat-flat-button>
                            <mat-icon [svgIcon]="'heroicons_outline:plus'"></mat-icon>
                            <span class="ml-2 mr-1">Order Service</span>
                        </button>
                    </div>
                </div>
                <div *ngIf="user.role === 'partner' && serviceManagement">
                    <div class="flex flex-col px-4 sm:px-8 my-auto space-y-6">
                        <button (click)="toggleEditMode(true)" [color]="'primary'" mat-flat-button>
                            <mat-icon [svgIcon]="'heroicons_outline:pencil'"></mat-icon>
                            <span class="ml-2 mr-1">Edit</span>
                        </button>
                    </div>
                </div>
            </div>

            <div *ngIf="paymentStatus === 'failed'"
                class="w-full text-red-700 text-center pb-2 bg-gray-100 dark:bg-gray-700 dark:text-red-400 font-semibold">
                {{t('payment-failed')}}</div>
            <div *ngIf="paymentStatus === 'cancelled'"
                class="w-full text-red-700 text-center pb-2 bg-gray-100 dark:bg-gray-700 dark:text-red-400 font-semibold">
                {{t('payment-cancelled')}}</div>
        </div>

        <ng-container *ngIf="editMode">
            <div
                class="flex flex-0 w-full self-center items-center justify-between h-16 pr-3 sm:pr-5 pl-6 sm:pl-8 bg-primary text-on-primary">
                <div class="text-lg font-medium invisible md:visible">
                    {{serviceForm.get('title').value}}
                </div>

                <div class="flex space-x-4 items-center justify-center">
                    <button (click)="matDialogRef.close()" [tabIndex]="-1" mat-icon-button>
                        <mat-icon [svgIcon]="'heroicons_outline:x-mark'" class="text-current"></mat-icon>
                    </button>
                </div>
            </div>

            <div class="flex flex-col">
                <form (ngSubmit)="onSubmit()" [formGroup]="serviceForm"
                    class="grid grid-cols-12 gap-6 items-start w-full p-6 sm:p-8 pb-2 overflow-y-auto"
                    id="service-form">

                    <mat-form-field class="fuse-mat-textarea fuse-mat-no-subscript col-span-12">
                        <mat-label>Title</mat-label>
                        <input [formControlName]="'title'" autocomplete="off" matInput required>
                    </mat-form-field>

                    <mat-form-field class="fuse-mat-textarea fuse-mat-no-subscript col-span-8 md:col-span-4">
                        <mat-label>Service Type</mat-label>
                        <mat-select [formControlName]="'type'" required>
                            <mat-option value="promotion">
                                {{t('promotion')}}
                            </mat-option>
                            <mat-option value="distribution">
                                {{t('distribution')}}
                            </mat-option>
                            <mat-option value="tool">
                                {{t('tool')}}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>

                    <mat-form-field class="fuse-mat-textarea fuse-mat-no-subscript col-span-4">
                        <mat-label>Pricing</mat-label>
                        <input [formControlName]="'price'" autocomplete="off" matInput min="0" required type="number">
                    </mat-form-field>

                    <mat-form-field class="fuse-mat-textarea fuse-mat-no-subscript col-span-12 md:col-span-4">
                        <mat-label>Image</mat-label>
                        <mat-select [formControlName]="'image'" id="serviceImageSelect" required>
                            <mat-select-trigger>
                                {{getCurrentImageName()}}
                            </mat-select-trigger>
                            <ng-container *ngFor="let image of images">
                                <mat-option [value]="image.url">
                                    <div class="flex flex-row">
                                        <div class="service-image-container h-16 w-16 mr-6 flex align-middle">
                                            <div *ngIf="image.url.endsWith('.svg')" [inlineSVG]="image.url"
                                                class="my-auto"></div>
                                            <img *ngIf="!image.url.endsWith('.svg')" [src]="image.url"
                                                alt="{{image.name}}" class="h-10 w-12 rounded object-cover" />
                                        </div>
                                        <span class="my-auto">{{image.name}}</span>
                                    </div>
                                </mat-option>
                            </ng-container>
                        </mat-select>
                    </mat-form-field>

                    <mat-form-field class="fuse-mat-textarea fuse-mat-no-subscript col-span-12">
                        <mat-label>Description</mat-label>
                        <mat-icon [svgIcon]="'heroicons_solid:pencil-square'" class="hidden sm:flex icon-size-5"
                            matPrefix>
                        </mat-icon>
                        <textarea [formControlName]="'description'"
                            [placeholder]="'Describe the service to your customers'" [rows]="5" [spellcheck]="true"
                            matInput matTextareaAutosize></textarea>
                    </mat-form-field>

                    <mat-form-field *ngIf="availableServiceFunctions?.length"
                        class="fuse-mat-textarea fuse-mat-no-subscript col-span-12">
                        <mat-label>Service Function (optional)</mat-label>
                        <mat-select [formControlName]="'serviceFunctionUuid'">
                            <mat-option [value]="null">No function</mat-option>
                            <ng-container *ngFor="let serviceFunction of availableServiceFunctions">
                                <mat-option [value]="serviceFunction.uuid">
                                    <div class="flex flex-col">
                                        <div class="flex align-middle font-semibold">
                                            {{serviceFunction.title}}
                                        </div>
                                        <span class="my-auto">- {{serviceFunction.description}}</span>
                                    </div>
                                </mat-option>
                            </ng-container>
                        </mat-select>
                    </mat-form-field>

                    <ng-container *ngIf="getSelectedServiceFunction()?.title === 'Express Delivery'">
                        <mat-divider class="py-2 col-span-12"></mat-divider>

                        <div class="font-semibold col-span-12">Service Restrictions</div>

                        <mat-form-field
                            class="fuse-mat-textarea fuse-mat-no-subscript col-span-12 sm:col-span-6 lg:col-span-4">
                            <mat-label>Min. Published Releases</mat-label>
                            <input [formControlName]="'minPublishedReleases'" autocomplete="off" matInput min="0"
                                type="number" />
                        </mat-form-field>

                        <mat-form-field
                            class="fuse-mat-textarea fuse-mat-no-subscript col-span-12 sm:col-span-6 lg:col-span-4">
                            <mat-label>Max. Rejected Releases</mat-label>
                            <input [formControlName]="'maxRejectedReleases'" autocomplete="off" matInput min="0"
                                type="number" />
                        </mat-form-field>

                        <mat-form-field
                            class="fuse-mat-textarea fuse-mat-no-subscript col-span-12 sm:col-span-6 lg:col-span-4">
                            <mat-label>Min. Account Age</mat-label>
                            <input [formControlName]="'minAccountAgeDays'" autocomplete="off" matInput min="0"
                                type="number" />
                            <span matSuffix style="margin-top: 2px">Days</span>
                        </mat-form-field>
                    </ng-container>

                    <mat-error class="col-span-12" *ngIf="getSelectedServiceFunction()?.visible === false">This service
                        will not be listed in the Services tab. Instead, it provides special functionality in other
                        places of the platform.<br><br>The icon and description you enter will remain unused. Only the
                        pricing and restrictions are important.
                    </mat-error>

                </form>

                <div class="flex w-full justify-between p-4 mt-auto">
                    <button (click)="onCancel()" class="mt-4" mat-stroked-button>
                        <span>Cancel</span>
                    </button>
                    <button [color]="'primary'" class="mt-4" form="service-form" mat-flat-button type="submit">
                        <span>Save</span>
                    </button>
                </div>
            </div>
        </ng-container>

    </div>
</ng-container>
